import ArrowBackIcon from '@mui/icons-material/ArrowBackIos';
import { useHistory } from 'react-router-dom';

export default function GoBackButton({ className }: { className?: string }) {
    const history = useHistory();

    return (
        <button
            onClick={() => history.goBack()}
            className={`flex items-center z-10 border border-primary/10 rounded-[12px] px-[10px] py-[8px] bg-white ${className}`}
        >
            <ArrowBackIcon className="text-[12px]" />
            <span>Back</span>
        </button>
    );
}
